import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AjaxService } from 'src/app/service/ajax.service';
import { API } from 'src/environments/environment';

interface Advogado {
  id: number;
  cognome: string;
  nome: string;
  telefono: string;
  email: string;
  pec: string;
  cf: string;
  piva: string;
  indirizzo: string;
  linguaPortoghese: boolean;
  linguaSpagnolo: boolean;
  linguaInglese: boolean;
  cassazionista: boolean;
}

@Component({
  selector: 'app-cadastro-advogado',
  templateUrl: './cadastro-advogado.component.html',
  styleUrls: ['./cadastro-advogado.component.scss']
})
export class CadastroAdvogadoComponent implements OnInit {
  cadastroForm: FormGroup;
  advogados: any[] = [];
  advogadosFiltrados: any[] = [];
  modalRef: NgbModalRef;
  advogadoSelecionado: any;
  loading: boolean = false;

  // Propriedades para filtros
  filtroNome: string = '';
  filtroCognome: string = '';
  filtroLingua: string = '';
  filtroCassazionista: string = '';

  // Máscaras para os campos
  telefoneMask = ['+', '3', '9', ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/];
  cfMask = [/[A-Z]/, /[A-Z]/, /[A-Z]/, /[A-Z]/, /[A-Z]/, /[A-Z]/, /\d/, /\d/, /[A-Z]/, /\d/, /[A-Z]/, /\d/, /[A-Z]/, /\d/, /[A-Z]/, /[A-Z]/];
  pivaMask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private ajaxService: AjaxService
  ) {
    this.cadastroForm = this.fb.group({
      id: [''],
      cognome: ['', Validators.required],
      nome: ['', Validators.required],
      telefono: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      pec: ['', [Validators.required]],
      cf: ['', [Validators.required]],
      piva: ['', [Validators.required, Validators.pattern(/^\d{11}$/)]],
      indirizzo: ['', Validators.required],
      linguaPortoghese: [false],
      linguaSpagnolo: [false],
      linguaInglese: [false],
      cassazionista: [false]
    });
  }

  ngOnInit() {
    this.carregarAdvogados();
  }

  carregarAdvogados() {
    this.loading = true;
    let url = API + "UsuarioAdvogado/UsuarioAdvogado";
    this.ajaxService.get(url).subscribe({
      next: (response) => {
        this.advogados = response.data;
        this.advogadosFiltrados = [...this.advogados];
        this.loading = false;
      },
      error: (error) => {
        console.error('Erro ao carregar advogados:', error);
        this.loading = false;
      }
    });
  }

  aplicarFiltros() {
    this.advogadosFiltrados = this.advogados.filter(advogado => {
      const matchNome = !this.filtroNome || 
        advogado.nome.toLowerCase().includes(this.filtroNome.toLowerCase());
      
      const matchCognome = !this.filtroCognome || 
        advogado.cognome.toLowerCase().includes(this.filtroCognome.toLowerCase());
      
      const matchLingua = !this.filtroLingua || 
        advogado[this.filtroLingua] === true;

      const matchCassazionista = !this.filtroCassazionista || 
        advogado.cassazionista === (this.filtroCassazionista === 'true');

      return matchNome && matchCognome && matchLingua && matchCassazionista;
    });
  }

  limparFiltros() {
    this.filtroNome = '';
    this.filtroCognome = '';
    this.filtroLingua = '';
    this.filtroCassazionista = '';
    this.advogadosFiltrados = [...this.advogados];
  }

  openModal(content: any, limparform=false): void {
    if(limparform){
      this.advogadoSelecionado = null;
      this.cadastroForm.patchValue({
        id: "",
        cognome: "",
        nome: "",
        telefono: "",
        email: "",
        pec: "",
        cf: "",
        piva: "",
        indirizzo: "",
        linguaPortoghese: false,
        linguaSpagnolo: false,
        linguaInglese: false,
        cassazionista: false
      });
    }
     
    this.modalRef = this.modalService.open(content, { size: 'lg' });
  }

  onSubmit() {
    if (this.cadastroForm.valid) {
      const formData = this.cadastroForm.value;

      let dados = {        
        "COGNOME": formData.cognome,
        "NOME": formData.nome,
        "TELEFONO": formData.telefono,
        "EMAIL": formData.email,
        "PEC": formData.pec,
        "CF": formData.cf,
        "PIVA": formData.piva,
        "INDIRIZZO_STUDIO": formData.indirizzo,
        "LINGUE_PORTOGHESE": formData.linguaPortoghese ? true : false,
        "LINGUE_SPAGNOLO": formData.linguaSpagnolo ? true : false,
        "LINGUE_INGLESE": formData.linguaInglese ? true : false,
        "CASSAZIONISTA": formData.cassazionista ? true : false
      }

      if (this.advogadoSelecionado != null) {
        let url = API + "Usuario/Usuario/advogado";
        dados["ID_USUARIO_ADVOGADO"] = this.advogadoSelecionado.iD_USUARIO_ADVOGADO;
        dados["ID_USUARIO"] = this.advogadoSelecionado.iD_USUARIO;
        // Atualizar advogado existente
        this.ajaxService.post(url, dados).subscribe({
          next: (response) => {
            this.carregarAdvogados();
            this.modalRef.dismiss();
            this.cadastroForm.reset();
          },
          error: (error) => {
            console.error('Erro ao atualizar advogado:', error);
          }
        });
      } else {
        let url = API + "Usuario/Usuario/advogado";
        // Criar novo advogado
        this.ajaxService.post(url, dados).subscribe({
          next: (response) => {
            this.carregarAdvogados();
            this.modalRef.dismiss();
            this.cadastroForm.reset();
          },
          error: (error) => {
            console.error('Erro ao criar advogado:', error);
          }
        });
      }
    }
  }

  editarAdvogado(advogado: any) {
    
    this.advogadoSelecionado = advogado;
    this.cadastroForm.patchValue({
      id: advogado.id,
      cognome: advogado.cognome,
      nome: advogado.nome,
      telefono: advogado.telefono,
      email: advogado.email,
      pec: advogado.pec,
      cf: advogado.cf,
      piva: advogado.piva,
      indirizzo: advogado.indirizzO_STUDIO,
      linguaPortoghese: advogado.linguE_PORTOGHESE,
      linguaSpagnolo: advogado.linguE_SPAGNOLO,
      linguaInglese: advogado.linguE_INGLESE,
      cassazionista: advogado.cassazionista
    });
  }

  excluirAdvogado(id: number) {
    if (confirm('Tem certeza que deseja excluir este advogado?')) {
      this.ajaxService.delete(`Usuario/Usuario/advogado/${id}`).subscribe({
        next: () => {
          this.carregarAdvogados();
        },
        error: (error) => {
          console.error('Erro ao excluir advogado:', error);
        }
      });
    }
  }
} 